var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarQ = function SvgDefaultAvatarQ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 55.4c8.7 0 15.7-6.5 15.7-15.4 0-8.8-6.6-15.3-15.5-15.3-8.7 0-15.6 6.6-15.6 15.6 0 6.2 3.4 11.1 8.3 13.5h-.6c-2.6 0-4.8 1.2-4.8 2.4 0 .6.5 1 1.2 1 .9 0 1.4-.8 2.1-.9 3.9.3 10.5 5.6 16.3 5.6 5 0 8.4-3.9 8.4-5.3 0-.5-.3-.9-.9-.9-.8 0-1.1 1.1-1.9 1.6-.4.4-1.8 1-3.5 1-2.9 0-6.4-1.6-9.9-2.9h.7zM29.8 38.5c0-5.9 3.3-10.8 9.2-10.8 7.1 0 11.3 7.5 11.3 14.1 0 6-3.4 10.7-9.3 10.7-7.1-.1-11.2-7.6-11.2-14z"
  })));
};
export default SvgDefaultAvatarQ;